<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="detail && detail.name"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 短剧 -->
      <a-form-item
        label="短剧"
        name="export_drama_id"
        :rules="[{ required: true, message: '请选择短剧' }]"
      >
        <a-select
          show-search
          placeholder="请选择"
          v-model:value="formState.export_drama_id"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="drama in dramaList"
            :key="`${drama.id}-${drama.name}`"
            :value="drama.id"
          >
            {{ drama.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 覆盖版本 -->
      <a-form-item
        label="覆盖版本"
        name="type"
        :rules="[{ required: true, message: '请选择覆盖版本' }]"
      >
        <a-select
          v-model:value="formState.type"
          placeholder="请选择"
        >
          <template
            v-for="item in YoutubeVideoTypes"
          >
            <a-select-option
              v-if="item.value !== 2"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { YoutubeVideoTypes } from '@/utils/constantList'
import { dramaAll, ytVideoExport } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 短剧信息
let detail = ref(null)
// 短剧列表
let dramaList = ref([])
// 剧集信息
let formState = reactive({
  // 导入片库剧ID
  export_drama_id: undefined,
  // 覆盖版本
  type: undefined,
})


// 打开抽屉
function showDrawer (value) {
  // 展开
  visible.value = true
  // 详情
  detail.value = value
  // 获取选择项列表
  getSelectList()
}

// 获取选择项列表
function getSelectList () {
  dramaAll().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      dramaList.value = data
    }
  })
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 表单重置
    RefForm.value.resetFields()
    formState.type = undefined
    visible.value = false
  }
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      drama_id: detail.value.id,
      export_drama_id: formState.export_drama_id,
      type: formState.type,
    }
    ytVideoExport(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  // width: 118px;
  // height: 148px;
  width: 208px;
  height: 124px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>